import { render, staticRenderFns } from "./CreateNewPlanModal.vue?vue&type=template&id=3871781c"
import script from "./CreateNewPlanModal.vue?vue&type=script&lang=js"
export * from "./CreateNewPlanModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewPlanModal.vue?vue&type=style&index=0&id=3871781c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports